import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { getCaasTranslateHeader, HeaderConfigService } from '@os-components';
import { map, switchMap } from 'rxjs/operators';
import { WhatsNewResponse } from './whats-new.types';

@Injectable({
    providedIn: 'root',
})
export class WhatsNewService {
    public constructor(private http: HttpClient, private configService: HeaderConfigService) {}

    public fetchWhatsNewData() {
        return this.configService.cmsProject.pipe(
            switchMap((project) =>
                this.http
                    .get<WhatsNewResponse>(`/caas/direct/${project}/what-is-new`, getCaasTranslateHeader())
                    .pipe(map((response) => response._embedded['rh:doc'][0]))
            )
        );
    }
}
